
import Vue from 'vue'

export default Vue.extend({
  name: 'Stats',

  props: {
    stats: {
      type: Array,
    },
  },

  computed: {
    colsPerStat: function (): number {
      return this.stats.length > 2 ? 3 : 5
    },
  },

  data: () => ({}),
})
